import { useEffect } from "react";
import isMobile from "is-mobile";
import { Page } from "..";
import { UserInfoHeader } from "../../../modules/profile-dashboard/components/user-info-header";
import { AdminRail, AdminTopBar } from "../admin-rail";
import {
  LogoImg,
  ProfileContainer,
  TopContainer,
  TopMenuContainter,
} from "./styles";
import gph from "../../../assets/images/logo-georanking.png";

/**
 * Cabeçalho das telas do admin. No desktop é o menu lateral fixo mais a barra
 * superior (redesign V3); no celular continua o topo com o menu em gaveta.
 * O atributo no body é o que empurra o conteúdo para a direita do menu.
 */
export const HeaderAux: React.FC = () => {
  const mobile = isMobile();

  useEffect(() => {
    if (mobile) return;
    document.body.setAttribute("data-admin-shell", "");
    return () => document.body.removeAttribute("data-admin-shell");
  }, [mobile]);

  if (!mobile) {
    return (
      <>
        <AdminRail />
        <AdminTopBar />
      </>
    );
  }

  return (
    <TopContainer>
      <TopMenuContainter>
        <Page.NavBar /> <LogoImg src={gph} />
      </TopMenuContainter>
      <ProfileContainer>
        <UserInfoHeader balance={0} userName="" userRole="Gestor de Contas" />
      </ProfileContainer>
    </TopContainer>
  );
};
